import { BaseFormField } from "../../../../../../core/types/form-field.types";

export const displayProductItemData: Array<BaseFormField> = [
  {
    fieldName: 'nmId',
    label: 'Артикул'
  },
  {
    fieldName: 'subjectName',
    label: 'Категория на МП'
  },
  {
    fieldName: 'vendorCode',
    label: 'Артикул продовца'
  },
  {
    fieldName: 'brand',
    label: 'Бренд'
  }
]
